import React from 'react';
import { Helmet } from 'react-helmet-async';

import { useTranslation } from 'app/lang';
import Footer from 'app/modules/Layout/Footer';
import { getBrandName } from 'app/packages/brand';
import ErrorBoundary from 'app/widgets/ErrorBoundary';

import Live from './LiveDeferred';

import dictionary from './Live.dictionary.json';

function LivePage() {
  const { t } = useTranslation();
  const isAdvancedMeta = getBrandName() === 'komyob';
  const title = isAdvancedMeta
    ? t(dictionary.advancedTitle)
    : t(dictionary.title);

  const description = isAdvancedMeta
    ? t(dictionary.advancedDescription)
    : t(dictionary.description);

  return (
    <>
      <Helmet>
        <meta name="description"
              content={description} />

        <title>{title}</title>
      </Helmet>

      <ErrorBoundary>
        <Live />
        <Footer />
      </ErrorBoundary>
    </>
  );
}

export default LivePage;
